import { DateTimePicker } from "@mui/x-date-pickers-pro";
import { useCallback, type ComponentProps } from "react";
import type { Dayjs } from "dayjs";
import type { PickerChangeHandlerContext } from "@mui/x-date-pickers/models";
import type { DateTimeValidationError } from "@mui/x-date-pickers/models";

export type SafeDateTimePickerProps = Omit<
  ComponentProps<typeof DateTimePicker>,
  "onChange"
> & {
  onChange?: (
    value: Dayjs | null,
    context: PickerChangeHandlerContext<DateTimeValidationError>
  ) => void;
  onInvalidDate?: () => void;
};

export function SafeDateTimePicker({
  onChange,
  onInvalidDate,
  ...rest
}: SafeDateTimePickerProps) {
  const handleChange = useCallback(
    (
      value: Dayjs | null,
      context: PickerChangeHandlerContext<DateTimeValidationError>
    ) => {
      const hasValidationError = context.validationError != null;
      const isValidValue = value == null || value.isValid();

      if (hasValidationError || !isValidValue) {
        onInvalidDate?.();
        return;
      }

      onChange?.(value, context);
    },
    [onChange, onInvalidDate]
  );

  return <DateTimePicker {...rest} onChange={handleChange} />;
}
